import { render, staticRenderFns } from "./UIValueSlider.vue?vue&type=template&id=4595a004&scoped=true"
import script from "./UIValueSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./UIValueSlider.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UIValueSlider.vue?vue&type=style&index=0&id=4595a004&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4595a004",
  null
  
)

export default component.exports